<template>
    <div class="search-bar" ref="searchBar" v-click-outside="hideResults">
        <v-layout class="search-bar-bar hidden-sm-and-down">
            <v-select class="search-bar-select" prepend-inner-icon="search" solo-inverted flat :items="searchItems"
                      v-model="searchType" ref="searchtype"/>
            <v-text-field class="search-bar-field" solo-inverted flat hide-details label="Søk..." v-model="search"
                          @click="resultsVisible=true" ref="searchbar" :loading="loading"/>
            <v-progress-circular class="search-bar-loading" indeterminate v-if="loading" color="grey"/>
        </v-layout>
        <v-card v-if="results && resultsVisible" class="search-results elevation-5" light>
            <v-layout class="overflow-hidden">
                <v-flex v-for="column in results" class="search-bar-column" :key="column.title">
                    <SearchResultColumn :column="column" :reset-and-hide-results="resetAndHideResults"/>
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>

<script>
    import {debounce} from 'lodash';
    import SearchResultColumn from "./SearchResultColumn";

    export default {
        components: {
            SearchResultColumn
        },
        data() {
            return {
                searchType: 'all',
                search: '',
                loading: false,
                resultsVisible: false,
                results: []
            }
        },

        watch: {
            searchType() {
                this.$refs['searchbar'].focus();
            },
            search() {
                this.updateSearch();
            }
        },

        methods: {
            updateSearch: debounce(function () {
                if (this.search.length < 2) return;

                this.loading = true;
                let params = {
                    type: this.searchType,
                    q: this.search
                };

                if(this.showArchived) {
                    params['archive'] = 1;
                }

                this.$http.get('search', {params}).then(response => {
                    this.results = response.data;
                    this.resultsVisible = true;
                }).finally(() => {
                    this.loading = false;
                });
            }, 500),
            hideResults() {
                this.resultsVisible = false;
            },
            resetAndHideResults() {
                this.hideResults();
                this.search = '';
            }
        },

        computed: {
            searchItems() {
                return [
                    {text: 'Fullstendig søk', value: 'all'},
                    {text: 'Søk i kunder', value: 'customers'},
                    {text: 'Bil / Reg.nr.', value: 'cars'},
                    {text: 'Dekkmerke', value: 'tire_storages.brand'},
                    {text: 'Dekkdimensjoner', value: 'tire_storages.size'},
                    {text: 'Lokasjon', value: 'tire_storages.location'}
                ];
            },

            showArchived() {
                return !!this.$route.query['is_deleted'];
            }
        }
    }
</script>

<style>
    .search-bar {
        width: 80%;
        align-items: center;
        margin-top: 28px;
    }

    .search-bar-bar {
        display: grid !important;
        grid-template-columns: 1fr 3fr;
        grid-gap: 0.5rem;
        position: relative;
    }

    .search-bar-loading {
        position: absolute;
        right: 1rem;
        margin-top: 0.4rem;
    }

    .search-bar-select {
        white-space: nowrap;
        align-items: center;
    }

    .search-bar-select i.icon {
        color: rgba(255, 255, 255, 0.7) !important;
    }

    .search-results {
        position: absolute !important;
        top: 64px;
        left: 5px;
        right: 5px;
    }

    .v-input--is-focused .v-icon {
        color: #fff !important;
    }

    @media (min-width: 1280px) {
        .search-bar {
            width: 50%;
        }

        .search-bar {
            position: relative !important;
        }

        .search-results {
            top: 54px;
            left: 0;
            right: 0;
        }
    }

</style>
